import {config} from '@config';
import {ConnectedComponent} from 'lowkey-component';

import {appSelectors} from '@store/appSlice';

export class KvSlider extends ConnectedComponent {
  private intervalId = -1;
  private timeoutId = -1;
  private duration: number = config.kvDuration;
  private slides: HTMLElement[] = [];
  private activeSlideIndex = 0;
  private progress: HTMLDivElement | undefined = undefined;

  didMount() {
    this.progress = document.querySelector(
      '.s-kv_progress_value',
    ) as HTMLDivElement;

    this.observe(appSelectors.selectSiteIndicatorStatus, async (status) => {
      if (status === 'hidingAnimation') {
        this.onEndHideAnimation();
        this.onStartHideAnimation();
      }
    });
    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'hidingAnimation') {
        this.onEndHideAnimation();
        this.onStartHideAnimation();
      }
    });
    this.observe(appSelectors.selectOrientation, async () => {
      // this.onChangeOrientation();
    });
    // 最初に表示したいdomが後にくる(z-indexの都合）
    this.slides = this.element
      ? (
          [
            ...this.element.querySelectorAll('.o-kv-slider_slide'),
          ] as HTMLElement[]
        ).reverse()
      : [];
  }

  // onChangeOrientation() {
  //   if (this.mq.isPhone()) {
  //     const height = window.innerHeight;
  //     if (this.element) {
  //       // this.element.style.height = `${height}px`;
  //     }
  //   }
  // }

  didUnmount() {
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
  }

  onEndHideAnimation() {
    this.element?.classList.add('exec');
    this._exec(true);
  }

  onStartHideAnimation() {
    if (this.element) {
      this.element.classList.add('init');
    }
    // setTimeout(() => {
    // }, 1000)

    window.clearInterval(this.intervalId);
    this.intervalId = window.setInterval(() => {
      // this.intervalId = window.setTimeout(() => {
      this._exec(false);
      this.element?.classList.add('prepare');
    }, this.duration);
  }

  getNextSlide() {
    if (this.activeSlideIndex >= this.slides.length) {
      this.activeSlideIndex = 0;
    }
    if (this.activeSlideIndex <= -1) {
      this.activeSlideIndex = 0;
    }
    const ret = this.slides[this.activeSlideIndex];
    ret.classList.add('active');
    this.activeSlideIndex++;
    return ret;
  }

  _exec(first: boolean) {
    if (!first) {
      this.slides.map((slide) => {
        slide.classList.remove('prev');
        if (slide.classList.contains('active')) {
          slide.classList.remove('active');
          slide.classList.add('prev');
        }
      });
    }
    const nextSlide = this.getNextSlide();
    nextSlide.classList.add('active');

    const delay = 300;
    if (this.progress) {
      this.progress.style.transition = 'none';
      this.progress.style.transform = 'scaleX(0.0)';

      // this.progress.style.transition = `${config.kvDuration}ms linear`
      // this.progress.style.transform = 'scaleX(1.0)'
      setTimeout(() => {
        if (this.progress) {
          this.progress.style.transition = `${
            config.kvDuration - delay
          }ms linear`;
          this.progress.style.transform = 'scaleX(1.0)';
        }
      }, delay);
    }
  }
}
